import {Injectable, Injector} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {tap, catchError} from 'rxjs/operators';
import {DialogUtilService} from '../../@shared/utils/dialog-util/dialog-util.service';
import {AuthService} from '../../auth/auth.service';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MerchantService {
  private currentMerchantSubject: BehaviorSubject<any>;
  public currentMerchant$: Observable<any>;

  private openDialog = false;

  constructor(private http: HttpClient, private dialogUtilService: DialogUtilService, private injector: Injector) {
    this.currentMerchantSubject = new BehaviorSubject<any>(this.getCurrentMerchantFromLocalStorage());
    this.currentMerchant$ = this.currentMerchantSubject.asObservable();
  }

  setCurrentMerchant(merchant: any): Observable<any> {
    // Fetch fresh merchant data from API to get latest staffMealConfig
    if (merchant && merchant.id) {
      return this.http.post<any>(`${environment.apiUrl}/api/merchant/getMerchant`, { id: merchant.id }).pipe(
        tap((freshMerchant) => {
          this.currentMerchantSubject.next(freshMerchant);
          this.saveCurrentMerchantToLocalStorage(freshMerchant);
        }),
        catchError((error) => {
          // Fallback to original merchant if API fails
          console.error('Failed to fetch fresh merchant data:', error);
          this.currentMerchantSubject.next(merchant);
          this.saveCurrentMerchantToLocalStorage(merchant);
          return of(merchant);
        })
      );
    } else {
      this.currentMerchantSubject.next(merchant);
      this.saveCurrentMerchantToLocalStorage(merchant);
      return of(merchant);
    }
  }

  getCurrentMerchant(): any {
    if (this.openDialog == false && !this.getCurrentMerchantFromLocalStorage()) {
      this.openDialog = true;

      const auth = this.injector.get(AuthService);
      const options = auth.getCurrentUser().merchants;

      // this.openDialogMerchant();
      if (options.length == 1) {
        this.setCurrentMerchant(options[0]).subscribe();
        // location.reload();
      } else {
        this.openDialogMerchant();
      }
    }
    return this.currentMerchantSubject.value;
  }

  private getCurrentMerchantFromLocalStorage(): any {
    const merchantJson = localStorage.getItem('dposCurrentMerchant');

    return merchantJson === null || merchantJson === 'undefined' ? null : JSON.parse(merchantJson);
  }

  private saveCurrentMerchantToLocalStorage(merchant: any) {
    localStorage.setItem('dposCurrentMerchant', JSON.stringify(merchant));
  }

  public removeCurrentMerchantFromLocalStorage() {
    localStorage.removeItem('dposCurrentMerchant');
  }

  openDialogMerchant() {
    this.dialogUtilService.openMerchantDialog().subscribe((confirm) => {
      if (confirm) {
        location.reload();
      }
      this.openDialog = false;
    });
  }
}
